import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../firebase";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import { PriceCheck } from "@mui/icons-material";
import discount from "../../../Assets/descuento.png";
import assistance from "../../../Assets/asistencia.png";
import uber from "../../../Assets/uber.png";
import cluppLogo from "../../../Assets/clupp-logo.png";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import handleErrorLandings from "../handleErrorLandings";
import LoyaltyLevelStep from "./LoyaltyLevelStep";

const landingId = "CF_LOYALTY_LEVEL_STEP";

const onLoad = async ({ session, landedAt, uid, navigate }) => {
  try {
    const prevAnswers = {};
    const prevForm = await getFormSession(
      "cancelation-form",
      session.sessionID
    );
    const landings = prevForm.items;
    landings.forEach((item) => {
      if (item?.answers?.length > 0) {
        const lastField = item.answers[0];
        const fieldID = lastField.field.id;
        const lastFieldType = lastField.type;
        const lastFieldAnswers = lastField[lastFieldType]?.value;
        prevAnswers[fieldID] = lastFieldAnswers;
      }
    });
    const pageSettedData = {};
    const userDoc = doc(db, "users", uid);
    const userSnapshot = await getDoc(userDoc);
    let user = { uid };
    if (userSnapshot.exists()) {
      user = { user, ...userSnapshot.data() };
    }

    const level = user?.level || 1;
    const levelsName = {
      1: "Azul",
      2: "Plata",
      3: "Oro",
    };

    const vehiclesCollection = collection(db, `users/${uid}/vehicles`);
    const vehiclesQuery = query(
      vehiclesCollection,
      where("isInsured", "==", true),
      where("deleted", "==", false),
      orderBy("liabilityInsuranceStartTimestamp", "asc"),
      limit(1)
    );

    const vehiclesSnapshot = await getDocs(vehiclesQuery);
    const lastVehicle = vehiclesSnapshot.docs[0];
    const lastVehicleData = { id: lastVehicle.id, ...lastVehicle.data() };
    const currentDate = new Date();
    const insuranceStartDate = new Date(
      lastVehicleData.insuranceStartTimestamp
    );

    const monthsDifference =
      (currentDate.getFullYear() - insuranceStartDate.getFullYear()) * 12 +
      (currentDate.getMonth() - insuranceStartDate.getMonth());

    let monthsToNextLevel;

    if (monthsDifference < 6) {
      monthsToNextLevel = 6 - monthsDifference;
    } else if (monthsDifference < 12) {
      monthsToNextLevel = 12 - monthsDifference;
    } else {
      monthsToNextLevel = 0;
    }
    const benefitsFromlevel = {
      1: [
        {
          name: "Alcanza el nivel Plata para obtener los primeros beneficios",
          icon: (
            <img
              alt=""
              src={cluppLogo}
              style={{ width: "30px", height: "30px" }}
            />
          ),
        },
      ],
      2: [
        {
          name: "Asistencias al doble",
          description:
            "¡Tus asistencias se duplican! Al ser nivel Plata tienes acceso a 6 servicios de asistencia al año: grúa (máximo 2 al año), cambio de llanta, paso de corriente, cerrajero y gasolina.",
          icon: (
            <img
              alt=""
              src={assistance}
              style={{ width: "30px", height: "30px" }}
            />
          ),
        },
        {
          name: "Reducción de prima",
          description:
            "¡Paga menos por tu seguro! Al ser nivel Plata tu prima se reduce automáticamente un 0.5% cada mes.",
          icon: (
            <img
              alt=""
              src={discount}
              style={{ width: "30px", height: "25px" }}
            />
          ),
        },
      ],
      3: [
        {
          name: "Asistencias al doble",
          description:
            "¡Tus asistencias se duplican! Al ser nivel Oro tienes acceso a 6 servicios de asistencia al año: grúa (máximo 2 al año), cambio de llanta, paso de corriente, cerrajero y gasolina. ",
          icon: (
            <img
              alt=""
              src={assistance}
              style={{ width: "30px", height: "30px" }}
            />
          ),
        },
        {
          name: "Reducción de prima",
          description:
            "¡Paga menos por tu seguro! Al ser nivel Oro tu prima se reduce automáticamente un 1% cada mes.",
          icon: (
            <img
              alt=""
              src={discount}
              style={{ width: "30px", height: "25px" }}
            />
          ),
        },
        {
          name: "3 Servicios de uber al año",
          description:
            "Te regalamos 3 servicios de Uber al año por hasta $100 pesos cada uno.\n\nNo aplica para Uber Eats.",
          icon: (
            <img alt="" src={uber} style={{ width: "30px", height: "15px" }} />
          ),
          whatsappRedirect: (mail) => {
            return `https://wa.me/5215577460177?text=Hola%2C%20mi%20correo%20es%20${mail}%20y%20estoy%20en%20nivel%20Oro.%20Me%20gustaría%20solicitar%20un%20servicio%20de%20Uber.`;
          },
        },
        {
          name: "Cero deducible en tu primer accidente",
          description:
            "Al ser nivel Oro no pagas el deducible del primer accidente en el que resultes responsable.",
          icon: <PriceCheck sx={{ color: "inherit", fontSize: 30 }} />,
        },
      ],
    };
    pageSettedData.level = level;
    pageSettedData.levelName = levelsName[level];
    pageSettedData.benefitsFromlevel =
      level === 1 ? benefitsFromlevel[2] : benefitsFromlevel[level];
    pageSettedData.monthsToNextLevel = monthsToNextLevel;
    pageSettedData.nextLevel = levelsName[level !== 3 ? level + 1 : level];

    return {
      userId: uid,
      ...prevAnswers,
      ...pageSettedData,
      landedAt,
      prevForm,
      currentLanding: landingId,
    };
  } catch (error) {
    await handleErrorLandings({
      error,
      landingId,
      navigate,
      navigatePath: `/formulario/cancelacion/beneficios?uid=${uid}`,
      message: `[Error Fomulario Cacelación][Loyalty Level] Ocurrio un error al pedir la información\nlandingError: ${landingId}\nUID: ${uid}\nSessionID: ${session.sessionID}`,
    });
  }
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <LoyaltyLevelStep state={state} setState={setState} />
);

const nextPage = (props) =>
  `/formulario/cancelacion/beneficios?uid=${props.uid}`;
const prevPage = (props) => {
  const prevForm = props.prevForm;
  const lastItem = prevForm.items[prevForm.items.length - 1];
  const lastLandingID = lastItem.landingId;
  if (lastLandingID === "CF_OTHER_INSURANCE_QUOTATION") {
    return `/formulario/cancelacion/otro-seguro-cotizacion?uid=${props.uid}`;
  }
  if (lastLandingID === "CF_OFFER_DISCOUNT") {
    return `/formulario/cancelacion/descuento?uid=${props.uid}`;
  }
  if (lastLandingID === "CF_TRUST_IN_CLUPP") {
    return `/formulario/cancelacion/confianza?uid=${props.uid}`;
  }
  if (lastLandingID === "CF_DONT_LIKE_CLUPP") {
    return `/formulario/cancelacion/no-gusto?uid=${props.uid}`;
  }
  if (lastLandingID === "CF_UPSELL") {
    return `/formulario/cancelacion/upsell?uid=${props.uid}`;
  }
  if (lastLandingID === "CF_OFFER_PAUSE") {
    return `/formulario/cancelacion/pausar?uid=${props.uid}`;
  }
  if (lastLandingID === "CF_OFFER_DISCOUNT") {
    return `/formulario/cancelacion/descuento?uid=${props.uid}`;
  }
  if (lastLandingID === "CF_PROCEDURE_QUESTION") {
    return `/formulario/cancelacion/tramite?uid=${props.uid}`;
  }
  if (lastLandingID === "CF_OTHER_INSURANCE_QUESTIONS") {
    return `/formulario/cancelacion/otro-seguro?uid=${props.uid}`;
  }

  return `/formulario/cancelacion/razon?uid=${props.uid}`;
};
/* const prevPage = (props) => `/formulario/cancelacion/razon?uid=${props.uid}`; */

const fieldsStructure = [];

const loyaltyLevelProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default loyaltyLevelProps;
